"use client";

import { useEffect, useRef, useState } from "react";

export default function SourceTooltip({ information }: { information: string }) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen) return;

    function closeOnOutsideClick(event: PointerEvent) {
      if (!containerRef.current?.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("pointerdown", closeOnOutsideClick);
    return () => document.removeEventListener("pointerdown", closeOnOutsideClick);
  }, [isOpen]);

  return (
    <div
      ref={containerRef}
      className="group absolute top-0 left-0"
      onBlur={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) {
          setIsOpen(false);
        }
      }}
    >
      <button
        type="button"
        aria-label={`Source: ${information}`}
        aria-expanded={isOpen}
        onClick={() => setIsOpen((open) => !open)}
        className="flex size-6 cursor-pointer items-center justify-center rounded-full border border-fire text-sky"
      >
        <span className="font-serif text-sm leading-none" aria-hidden="true">
          i
        </span>
      </button>
      <span
        role="tooltip"
        className={`pointer-events-none absolute bottom-full left-0 z-10 mb-2 w-64 rounded-md bg-earth px-3 py-2 text-left text-sm leading-snug font-normal text-sand shadow-lg transition-opacity ${isOpen ? "opacity-100" : "opacity-0 group-hover:opacity-100 group-focus-within:opacity-100"}`}
      >
        {information}
      </span>
    </div>
  );
}
